import portfolioImage from "../../assets/portfolio-project.png";
import analogClock from "../../assets/analogClock.png";
import messengerApplication from "../../assets/messengerApplication.png"

export const projects = [
    {
    "id": 1,
    "image": portfolioImage,
    "title": "Portfolio Website (Responsive) using React",
    "github": "https://github.com/vatsaakash/portfolio",
    "demo": "https://vatsaakash.github.io/portfolio/",
    "brief":
      "https://github.com/vatsaakash/portfolio/blob/master/README.md"
  },
  {
    "id": 2,
    "image": analogClock,
    "title": "Analog Clock using JS",
    "github": "https://github.com/vatsaakash/analog_Clock",
    "brief":
      "https://github.com/vatsaakash/analog_Clock/blob/main/README.md"
  },
  {
    "id": 3,
    "image": messengerApplication,
    "title": "Messenger Application using ReactJS hosted on Firebase",
    "github": "https://github.com/vatsaakash/Messenger-Application-using-ReactJS-hosted-on-Firebase",
    "demo": "https://messenger-e9d8f.web.app/",
    "brief":
      "https://github.com/vatsaakash/Messenger-Application-using-ReactJS-hosted-on-Firebase/blob/master/README.md"
  }
]
